import React from 'react';

import { Link } from 'react-router-dom';

function StandardsAlignmentDeclaration() {
  return (
    <>

      <div className="bg-[#F9FAFB] min-h-screen font-sans">
        {/* Hero */}
        <div className="bg-white border-b border-gray-200">
          <div className="max-w-5xl mx-auto px-6 py-20 text-center">
            <span className="inline-block py-1 px-3 rounded-full bg-green-100 text-green-800 text-xs font-bold tracking-wide uppercase mb-4">
              For Freelancers & Emerging Teams
            </span>
            <h1 className="text-4xl md:text-5xl font-bold text-[#102A43] mb-6">Accountability Declaration</h1>
            <p className="text-xl text-gray-600 max-w-2xl mx-auto leading-relaxed mb-10">
              Signal your commitment to professional AI safety and accountability principles without the complexity of full enterprise declaration.
            </p>
            <Link to="/declare-alignment" className="inline-block px-8 py-4 bg-green-700 text-white font-bold rounded-sm hover:bg-green-600 transition-colors shadow-md">
              Start Your Declaration
            </Link>
          </div>
        </div>

        <div className="max-w-5xl mx-auto px-6 py-16 space-y-16">

          {/* Comparison Section */}
          <section className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden">
            <div className="grid md:grid-cols-2">
              <div className="p-8 border-b md:border-b-0 md:border-r border-gray-200 bg-[#F9FAFB]">
                <h3 className="text-xl font-bold text-[#102A43] mb-4">Alignment Declaration</h3>
                <ul className="space-y-3 text-sm text-[#64748B]">
                  <li className="flex gap-2"><span className="text-green-600">✓</span> For Freelancers & Small Teams</li>
                  <li className="flex gap-2"><span className="text-green-600">✓</span> Self-Attested Commitment</li>
                  <li className="flex gap-2"><span className="text-green-600">✓</span> Signals Professional Intent</li>
                  <li className="flex gap-2"><span className="text-green-600">✓</span> "Aligned" Registry Listing</li>
                </ul>
              </div>
              <div className="p-8">
                <h3 className="text-xl font-bold text-[#102A43] mb-4">Full declaration</h3>
                <ul className="space-y-3 text-sm text-[#64748B]">
                  <li className="flex gap-2"><span className="text-blue-600">✓</span> For Agencies & Production Teams</li>
                  <li className="flex gap-2"><span className="text-blue-600">✓</span> Verified Evidence Review</li>
                  <li className="flex gap-2"><span className="text-blue-600">✓</span> Signals Operational Maturity</li>
                  <li className="flex gap-2"><span className="text-blue-600">✓</span> "Declared" Registry Listing</li>
                </ul>
              </div>
            </div>
          </section>

          {/* Content from WhatIsAlignmentDeclaration (reiterated for landing page completeness) */}
           <section className="grid md:grid-cols-2 gap-12">
            <div>
              <h2 className="text-2xl font-bold text-[#102A43] mb-6">Who This Is For</h2>
              <p className="text-[#64748B] leading-relaxed mb-6">
                This program is designed for the thousands of independent consultants, freelancers, and early-stage builders who are shaping the AI landscape. You may not yet have the logs, matrices, and compliance officers required for Accountability Declaration, but you want to show clients that you are not a "cowboy."
              </p>
              <div className="flex flex-wrap gap-2">
                {['Freelancers', 'Consultants', 'Solopreneurs', 'Educators'].map(tag => (
                  <span key={tag} className="px-3 py-1 bg-gray-100 text-[#64748B] text-sm font-medium rounded-full">{tag}</span>
                ))}
              </div>
            </div>
            <div>
              <h2 className="text-2xl font-bold text-[#102A43] mb-6">What You Declare</h2>
              <div className="space-y-4">
                <div className="flex gap-4">
                  <div className="w-8 h-8 rounded-full bg-green-100 text-green-700 flex items-center justify-center font-bold flex-shrink-0">1</div>
                  <p className="text-[#64748B]">I understand AASC principles for accountability.</p>
                </div>
                <div className="flex gap-4">
                  <div className="w-8 h-8 rounded-full bg-green-100 text-green-700 flex items-center justify-center font-bold flex-shrink-0">2</div>
                  <p className="text-[#64748B]">I commit to applying these principles in my work.</p>
                </div>
                <div className="flex gap-4">
                  <div className="w-8 h-8 rounded-full bg-green-100 text-green-700 flex items-center justify-center font-bold flex-shrink-0">3</div>
                  <p className="text-[#64748B]">I will not misrepresent this as declaration.</p>
                </div>
              </div>
            </div>
          </section>

          <section className="bg-[#2F80ED] text-white p-10 rounded-lg text-center">
            <h2 className="text-2xl font-bold mb-4">Ready to differentiate yourself?</h2>
            <p className="text-gray-300 mb-8 max-w-2xl mx-auto">
              Join the registry of professionals committed to safe, accountable AI development.
            </p>
            <Link to="/declare-alignment" className="inline-block px-8 py-3 bg-white text-[#102A43] font-bold rounded hover:bg-gray-100 transition-colors">
              Declare Alignment Now
            </Link>
          </section>

        </div>
      </div>
    </>
  );
}

export default StandardsAlignmentDeclaration;